export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-skillshare-f20102d5b2391f1b7c5814ac181c6551.svg";